import { IFeed } from "../models/feed";

//Enums
export enum FeedActionType {
  SET_FEEDS = "SET_FEEDS",
  SET_FEED_DATA = "SET_FEED_DATA",
  ADD_FEED = "ADD_FEED",
  UPDATE_FEED = "UPDATE_FEED",
  DELETE_FEED = "DELETE_FEED",
  SET_LOADING = "SET_LOADING",
  RESET_STORE = "RESET_STORE",
}

//States
export type TFeedsState = {
  feeds: IFeed[];
  loading: boolean;
  numConnections?: number;
  maxNumConnections?: number;
};

interface ISetFeedsAction {
  type: FeedActionType.SET_FEEDS;
  payload: TFeedsState["feeds"];
}

interface ISetFeedDataAction {
  type: FeedActionType.SET_FEED_DATA;
  payload: {
    feeds: IFeed[];
    numConnections?: number;
    maxNumConnections?: number;
  };
}

interface IAddFeedAction {
  type: FeedActionType.ADD_FEED;
  payload: IFeed;
}

interface IUpdateFeedAction {
  type: FeedActionType.UPDATE_FEED;
  payload: { id: string; updates: Partial<IFeed> };
}

interface IDeleteFeedAction {
  type: FeedActionType.DELETE_FEED;
  payload: string; // feed ID
}

interface ISetLoadingAction {
  type: FeedActionType.SET_LOADING;
  payload: boolean;
}

interface IResetStoreAction {
  type: FeedActionType.RESET_STORE;
}

export type TFeedAction =
  | ISetFeedsAction
  | ISetFeedDataAction
  | IAddFeedAction
  | IUpdateFeedAction
  | IDeleteFeedAction
  | ISetLoadingAction
  | IResetStoreAction;
